
import Utils from "@/components/Utils";
import { defineComponent, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import isMobile from "ismobilejs";

export default defineComponent({
  setup(props, context) {
    context.emit("header", true);
    context.emit("contentShow", false);

    const main = ref<HTMLElement>();
    const router = useRouter();
    const mobile =
      isMobile(window.navigator).phone || isMobile(window.navigator).tablet;

    const close = () => {
      router.push("/park");
    };

    const resize = () => {
      if (main.value) main.value.style.height = Utils.contentHeight("px");
    };

    const pageTop = () => {
      document.querySelector(".video-container")?.scrollIntoView({
        block: "start",
        behavior: "smooth",
      });
    };

    onMounted(() => {
      resize();
      window.addEventListener("resize", () => resize());
    });

    return {
      main,
      close,
      mobile,
      pageTop,
    };
  },
});
